import { render, staticRenderFns } from "./rechrage.vue?vue&type=template&id=7c96150c&scoped=true"
import script from "./rechrage.vue?vue&type=script&lang=js"
export * from "./rechrage.vue?vue&type=script&lang=js"
import style0 from "./rechrage.vue?vue&type=style&index=0&id=7c96150c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96150c",
  null
  
)

export default component.exports